import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { PricePipe } from 'mbs-ui-shared@components/licenses/pipes/price.pipe';
import { catchError, of, take } from 'rxjs';

@Component({
  selector: 'mbs-enable-auto-renewal-modal',
  templateUrl: './enable-auto-renewal-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CommonModule, I18NextPipe, ModalComponent, ModalFooterDirective, PricePipe]
})
export class EnableAutoRenewalModalComponent {
  private cdr = inject(ChangeDetectorRef);

  public loading = false;
  public readonly alertType = MbsPopupType;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  enable(): void {
    this.loading = true;

    const request = typeof this.baseModal.data.request === 'function' ? this.baseModal.data.request() : this.baseModal.data.request;

    request
      .pipe(
        take(1),
        catchError((error) => {
          this.loading = false;
          return of(error);
        })
      )
      .subscribe((res) => {
        this.loading = false;
        this.cdr.detectChanges();
        if (!res?.error) {
          this.baseModal.save();
        }
      });
  }
}
